var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "onlineOrderConifg" },
    [
      _c("div", { staticClass: "profit-box" }, [
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [_vm._v("订单级子菜单")]),
          _c("div", [
            _vm._v(
              " 可见菜单：" +
                _vm._s(
                  _vm.childMenuTotal > 0 ? _vm.childMenuTotal + "个" : "未设置"
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog("viewFoodChild")
                    },
                  },
                },
                [_vm._v(" 查看 ")]
              ),
              _vm.foodType === "set" && _vm.hasEditRule
                ? [
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("setFoodChild")
                          },
                        },
                      },
                      [_vm._v(" 设置子菜单 ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [_vm._v("订单级城市黑名单")]),
          _c("div", [
            _vm._v(
              " 城市黑名单：" +
                _vm._s(
                  _vm.blackCityTotal > 0 ? _vm.blackCityTotal + "个" : "未设置"
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog("viewFoodCity")
                    },
                  },
                },
                [_vm._v(" 查看 ")]
              ),
              _vm.foodType === "set" && _vm.hasEditRule
                ? [
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("setFoodCity")
                          },
                        },
                      },
                      [_vm._v(" 设置黑名单 ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "profit" }, [
          _c("div", { staticClass: "title" }, [_vm._v("订单级品牌黑名单")]),
          _c("div", [
            _vm._v(
              " 品牌黑名单：" +
                _vm._s(
                  _vm.blackBrandTotal > 0
                    ? _vm.blackBrandTotal + "个"
                    : "未设置"
                ) +
                " "
            ),
          ]),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      return _vm.openDialog("viewBlack")
                    },
                  },
                },
                [_vm._v(" 查看 ")]
              ),
              _vm.foodType === "set" && _vm.hasEditRule
                ? [
                    _c("el-divider", { attrs: { direction: "vertical" } }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openDialog("setBlack")
                          },
                        },
                      },
                      [_vm._v(" 设置黑名单 ")]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "profit brand" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v("可用品牌" + _vm._s(_vm.totalCount) + "个"),
          ]),
          _c(
            "el-form",
            { ref: "searchForm", attrs: { model: _vm.searchForm, inline: "" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "城市", prop: "region_id" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "120px" },
                    attrs: {
                      options: _vm.citys,
                      props: {
                        checkStrictly: true,
                        emitPath: false,
                        expandTrigger: "hover",
                      },
                      clearable: "",
                      filterable: "",
                      "popper-class": "city-style",
                    },
                    model: {
                      value: _vm.searchForm.region_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "region_id", $$v)
                      },
                      expression: "searchForm.region_id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品牌名称", prop: "brand_name" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入品牌名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.brand_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "brand_name", $$v)
                      },
                      expression: "searchForm.brand_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.searchData },
                    },
                    [_vm._v(" 搜索 ")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.searchData("reset")
                        },
                      },
                    },
                    [_vm._v(" 重置 ")]
                  ),
                  _vm.hasExportRole
                    ? _c(
                        "el-button",
                        {
                          attrs: {
                            exportLoading: _vm.exportLoading,
                            type: "success",
                          },
                          on: { click: _vm.exportData },
                        },
                        [_vm._v(" 导出 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "text-align": "right", "margin-bottom": "10px" } },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "total, sizes, prev, pager, next, jumper",
                  "current-page": _vm.searchForm.page,
                  "page-size": _vm.searchForm.pagesize,
                  "page-sizes": [10, 20, 30, 40, 50, 100],
                  total: _vm.totalCount,
                },
                on: {
                  "size-change": function (size) {
                    return _vm.sizeChange("searchForm", size)
                  },
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticClass: "myTable",
              attrs: {
                "header-cell-style": {
                  background: "#f1f1f1",
                  color: "#333333",
                },
                data: _vm.tableData,
                height: "58vh",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "品牌图片",
                  width: "110px",
                  prop: "brand_image",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-image", {
                          attrs: {
                            src: scope.row.brand_image,
                            "preview-src-list": [scope.row.brand_image],
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "品牌名称",
                  width: "150px",
                  prop: "brand_name",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "覆盖城市",
                  "min-width": "180px",
                  align: "left",
                  prop: "city_name",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "text" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCityDialog(
                                        scope.row.city_tree
                                      )
                                    },
                                  },
                                },
                                [_vm._v(" 更多 ")]
                              ),
                              _vm._l(
                                scope.row.city_name,
                                function (item, index) {
                                  return [
                                    _vm._v(
                                      _vm._s(index !== 0 ? "，" : "") +
                                        _vm._s(item)
                                    ),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "门店数量",
                  width: "120px",
                  align: "center",
                  prop: "restaurant_count",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { padding: "0" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.toStore(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(scope.row.restaurant_count))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "商品数量",
                  width: "120px",
                  align: "center",
                  prop: "product_count",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(" " + _vm._s(scope.row.product_count) + " "),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showCityDialog,
            title: "覆盖城市",
            "lock-scroll": "",
            "append-to-body": "",
            top: "30px",
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCityDialog = $event
            },
            close: _vm.onClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "treeContent" },
            [
              _c(
                "div",
                { staticClass: "filter-input" },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "输入关键字进行过滤" },
                    model: {
                      value: _vm.filterText,
                      callback: function ($$v) {
                        _vm.filterText =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "filterText",
                    },
                  }),
                ],
                1
              ),
              _c("el-tree", {
                ref: "tree",
                staticClass: "filter-tree",
                attrs: {
                  data: _vm.cityList,
                  props: {
                    children: "children",
                    label: "label",
                  },
                  "filter-node-method": _vm.filterNode,
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.showCityDialog = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cake__dialog",
          attrs: {
            top: "7vh",
            title: "在线点单品牌黑名单",
            visible: _vm.onlineOrderDialog,
            width: "640px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.onlineOrderDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("div", { staticClass: "checked__cake" }, [
                _c("div", { staticClass: "checked__margin" }, [
                  _vm._v(" 已选品牌 "),
                  _vm.dialogType === "setBlack" && _vm.checkedOnlineOrder.length
                    ? _c(
                        "span",
                        {
                          staticClass: "clear",
                          on: { click: _vm.clearChecked },
                        },
                        [_vm._v("清空已选")]
                      )
                    : _vm._e(),
                ]),
                _vm.checkedOnlineOrder.length
                  ? _c(
                      "div",
                      _vm._l(_vm.checkedOnlineOrder, function (item, index) {
                        return _c(
                          "el-button",
                          {
                            key: item.brand_id,
                            staticStyle: { margin: "0 10px 10px 0" },
                            attrs: { type: "info", size: "small", plain: "" },
                            on: {
                              click: function ($event) {
                                return _vm.delCheckedCake(index)
                              },
                            },
                          },
                          [
                            _vm._v(" " + _vm._s(item.brand_name) + " "),
                            _vm.dialogType === "setBlack"
                              ? _c("span", {
                                  staticClass: "btn-icon el-icon-close",
                                })
                              : _vm._e(),
                          ]
                        )
                      }),
                      1
                    )
                  : _c("div", { staticClass: "empty__style" }, [
                      _vm._v("暂未选择品牌！"),
                    ]),
              ]),
              _c("div", { staticClass: "wait__margin" }, [_vm._v("待选品牌")]),
              _c(
                "div",
                [
                  _vm._v(" 品牌名称："),
                  _c("el-input", {
                    staticStyle: { width: "210px", margin: "5px 3px" },
                    attrs: { clearable: "", placeholder: "请选择不支持的品牌" },
                    model: {
                      value: _vm.searchBrand.brand_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchBrand, "brand_name", $$v)
                      },
                      expression: "searchBrand.brand_name",
                    },
                  }),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "medium",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.searchOnlineOrderList(1)
                        },
                      },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm.dialogType === "setBlack"
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "medium" },
                          on: { click: _vm.batchAddOnlineOrder },
                        },
                        [_vm._v("批量添加")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "multipleOnlineOrder",
                  attrs: {
                    data: _vm.onlineOrderList,
                    border: "",
                    height: "400px",
                    "header-cell-style": {
                      color: "#333333",
                      background: "#f1f1f1",
                    },
                  },
                  on: {
                    "select-all": _vm.handleSelectOnlineorder,
                    select: _vm.handleSelectOnlineorder,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      selectable: _vm.selectable,
                      width: "55",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "id", width: "80px", label: "ID" },
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "brand_name", label: "品牌" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "10px",
                    "margin-top": "10px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      layout: "prev, pager,sizes, jumper, next",
                      "page-sizes": [20, 2000],
                      "page-size": _vm.searchBrand.pagesize,
                      total: _vm.searchBrand.total_count,
                    },
                    on: {
                      "size-change": function (size) {
                        return _vm.sizeChange("searchBrand", size)
                      },
                      "current-change": _vm.searchOnlineOrderList,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { "margin-top": "-25px" },
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.onlineOrderDialog = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.dialogType !== "setBlack" || !_vm.hasEditRule,
                  },
                  on: { click: _vm.setBlackOnlineOrder },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }